(function (app) {

    InterviewActionsModalController.$inject = ["$scope", "$state", "modalData"];
    function InterviewActionsModalController($scope, $state, modalData) {

        $scope.submit = function () {

            $scope.submitting = true;

           if ($scope.modalStatus === $scope.MODAL_STATUSES.REQUEST_NEW_TIME) {

                InterviewV2API.requestNewTimeForInterview(modalData.interview_set_id, modalData.app_id, $.trim($scope.reason))
                    .then(function () {
                        $scope.submitting = false;
                        $scope.close();
                        $state.go("appLayout.harriSH.dashboard");
                    });

           } else if ($scope.modalStatus === $scope.MODAL_STATUSES.DENIED) {

               InterviewV2API.declineInterview(modalData.interview_set_id, modalData.app_id, $.trim($scope.reason))
                   .then(function () {
                       $scope.submitting = false;
                       $scope.close();
                       $state.go("appLayout.harriSH.dashboard");
                   });

           }
        };


        (function () {

            $scope.MODAL_STATUSES = {
                REQUEST_NEW_TIME: InterviewV2API.INTERVIEW_STATUSES.REQUEST_NEW_TIME,
                DENIED: InterviewV2API.INTERVIEW_STATUSES.DENIED
            };

            $scope.brandName = modalData.brand && modalData.brand.name;

            $scope.modalStatus = modalData.status;

        })();

        $scope.close = function () {
            $scope.$hide();
        };
    }

    app.controller('InterviewActionsModalController', InterviewActionsModalController);
})(angular.module('harriApp'));